import React from 'react';
import ProjectCard from '../ui/ProjectCard';
import { PORTFOLIO_DATA } from '../../utils/constants';
import './Projects.css';

const Projects = () => {
  return (
    <section id="projects" className="projects section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Projects</h2>
          <p className="section-subtitle">Recent work I've done</p>
        </div>
        
        <div className="projects-grid">
          {PORTFOLIO_DATA.projects.map((project) => (
            <ProjectCard key={project.id} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;